import moment from 'moment';

export const getLocalDateTime = () => {
  return moment(new Date().toLocaleString());
};

export const getFormattedTimeRange = () => {
  const hour = getLocalDateTime().hour();
  switch (true) {
    case hour >= 4 && hour < 12:
      return 'morning';
    case hour >= 12 && hour < 17:
      return 'afternoon';
    case hour >= 17 || hour < 4:
      return 'evening';
    default:
      return 'day';
  }
};

export const getDormatedDateLabel = (
  dates: string[] = [],
  granularity: string,
) => {
  return dates.map(e => {
    const date = moment(e);
    switch (granularity) {
      case 'day':
        return date.format('D MMM');
      case 'week':
        return date.format('Do MMMM');
      case 'month':
        return date.format('MMMM Y');
      default:
        return date.format('Do MMMM Y');
    }
  });
};

export const reduceWeeklyAnalyticsCounts = (
  dates: string[] = [],
  dataToMap: number[] = [],
) => {
  return dates.reduce((a, date, i) => {
    if (getLocalDateTime().isSame(moment(date), 'week')) {
      // tslint:disable-next-line:no-parameter-reassignment
      a += dataToMap[i];
    }
    return a;
  }, 0);
};
